import PoorNetToastMessage from './PoorNetToastMessage';
import { connect } from 'react-redux';
import {
  removeToastMessage,
  setRemovingToastMessage
} from '../ToastMessagesActions';
import { removingAllPoorNetToastMessages } from './PoorNetToastMessageActions';

const mapDispatchToProps = {
  removeToastMessage,
  setRemovingToastMessage,
  userClickAction: removingAllPoorNetToastMessages,
};

export default connect(null, mapDispatchToProps)(PoorNetToastMessage);
